"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const muiDivider = {
    styleOverrides: {
        root: {
            flexGrow: 1,
        },
    },
};
exports.default = muiDivider;
//# sourceMappingURL=muiDivider.js.map